var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPassportExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9954 7.33073V8.66406C14.9954 11.4927 14.9954 12.9067 14.0188 13.7854C13.0434 14.6641 11.4714 14.6641 8.32878 14.6641C5.18611 14.6641 3.61478 14.6641 2.63811 13.7854C1.66144 12.9067 1.66211 11.4921 1.66211 8.66406C1.66211 5.83606 1.66211 4.4214 2.63811 3.54273C3.61544 2.66406 5.18611 2.66406 8.32878 2.66406H8.99544",
    stroke: "#EEF3F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66211 11.6654C4.46744 9.9447 7.47011 9.83203 8.32878 11.6654M10.9954 1.33203L12.9954 3.33203M12.9954 3.33203L14.9954 5.33203M12.9954 3.33203L10.9954 5.33203M12.9954 3.33203L14.9954 1.33203M7.32878 6.9987C7.32878 7.35232 7.1883 7.69146 6.93825 7.94151C6.6882 8.19156 6.34906 8.33203 5.99544 8.33203C5.64182 8.33203 5.30268 8.19156 5.05263 7.94151C4.80259 7.69146 4.66211 7.35232 4.66211 6.9987C4.66211 6.64508 4.80259 6.30594 5.05263 6.05589C5.30268 5.80584 5.64182 5.66536 5.99544 5.66536C6.34906 5.66536 6.6882 5.80584 6.93825 6.05589C7.1883 6.30594 7.32878 6.64508 7.32878 6.9987Z",
    stroke: "#EEF3F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassportExpired);
export default __webpack_public_path__ + "static/media/IconPassportExpired.01bea0166f167b937d563948bf2fbaad.svg";
export { ForwardRef as ReactComponent };